import script from "./FormularioDespesa.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioDespesa.vue?vue&type=script&setup=true&lang=js"

import "./FormularioDespesa.vue?vue&type=style&index=0&id=ac6072ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac6072ba"]])

export default __exports__